import ReactDOM from "react-dom";
import { PlacesType, Tooltip as ReactTooltip } from "react-tooltip";

import styles from "./Tooltip.module.scss";

/**
 * The properties for a {@link Tooltip} component.
 */
interface ITooltipProps {
    /**
     * The content to show in the tooltip.
     */
    children: React.ReactNode;

    /**
    * Where the tooltip should be shown relative to the anchor.
    */
    place: PlacesType;

    /**
    * The CSS selector for the anchor element to use for relative positioning.
    */
    anchorSelect: string;

    /**
    * Whether the tooltip should be open.
    */
    isOpen?: boolean;
}

/**
 * A component which shows a tooltip near another element.
 */
function Tooltip(props: Readonly<ITooltipProps>): JSX.Element {
    return (
        // add tooltip to the document body so it's not restrained by the dimensions of its parent element
        ReactDOM.createPortal(
            <ReactTooltip
                place={props.place}
                anchorSelect={props.anchorSelect}
                className={`${styles["react-tooltip"]} ${styles["medfar-tooltip"]}`}
                offset={5}
                noArrow
                isOpen={props.isOpen}
                positionStrategy="absolute"
            >
                {props.children}
            </ReactTooltip>,
            document.body
        )
    );
}

export { ITooltipProps, Tooltip };
